import React from 'react';
import {Grid, Segment} from 'semantic-ui-react';

const PoliticaDePrivacidade = () => {

    return (
        <div suppressContentEditableWarning
             style={{backgroundImage: 'url(/login_bg.png)', backgroundSize: 'cover'}}>
            <Grid textAlign='center' style={{height: '100vh'}} verticalAlign='middle'>
                <Segment >
                    <h1>Política de Privacidade do FleetGame</h1>

                    <h2>1. Introdução</h2>

                    <p>A Política de Privacidade do FleetGame descreve como as informações pessoais dos usuários são coletadas e usadas pelo aplicativo FleetGame ("nós", "nosso" ou "aplicativo"). Ao usar o FleetGame, você concorda com as práticas de privacidade descritas nesta política.</p>

                    <h2>2. Informações Coletadas</h2>

                    <h3>2.1 Informações de Registro</h3>

                    <p>Para acessar o FleetGame, você precisará fazer login com seu CPF. Nós coletamos seu CPF para autenticação e identificação do usuário.</p>

                    <h2>3. Uso das Informações</h2>

                    <h3>3.1 Uso Interno</h3>

                    <p>As informações coletadas são usadas exclusivamente para a funcionalidade do FleetGame e não são utilizadas para compartilhamento com terceiros, a menos que seja exigido por lei.</p>

                    <h2>4. Política de Retenção de Dados</h2>

                    <h3>4.1 Retenção Limitada</h3>

                    <p>Mantemos seus dados apenas pelo tempo necessário para fornecer os serviços do FleetGame ou conforme exigido por lei. Após esse período, seus dados serão excluídos.</p>

                    <h2>5. Segurança</h2>

                    <h3>5.1 Medidas de Segurança</h3>

                    <p>Tomamos todas as medidas legais necessárias para proteger suas informações pessoais contra acesso não autorizado ou divulgação.</p>

                    <h2>6. Contato e Direitos do Usuário</h2>

                    <h3>6.1 Acesso, Retificação e Exclusão</h3>

                    <p>Para acessar, retificar ou solicitar a exclusão de seus dados da nossa base, entre em contato conosco pelo e-mail de contato: <a href="mailto:solucoesm2afleetgame@gmail.com">solucoesm2afleetgame@gmail.com</a> ou pelos telefones: (31) 2123-9967 ou WhatsApp (31) 98481-6706.</p>

                    <h2>7. Alterações na Política de Privacidade</h2>

                    <h3>7.1 Atualizações</h3>

                    <p>Podemos atualizar esta política de privacidade ocasionalmente. Quaisquer alterações serão publicadas nesta página.</p>
                </Segment>
            </Grid>
        </div>
    );
};

export default PoliticaDePrivacidade;
